/* IZZHAAR theme scripts — vanilla, no dependencies */
(function () {
  'use strict';
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ */
  /* Header: drawer, search                                               */
  /* ------------------------------------------------------------------ */
  function initHeader() {
    const drawer = $('#MenuDrawer');
    const openBtn = $('[data-drawer-open]');
    const closeEls = $$('[data-drawer-close]');
    if (drawer && openBtn) {
      const open = () => { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
      const close = () => { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
      openBtn.addEventListener('click', open);
      closeEls.forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
    const searchBtn = $('[data-search-toggle]');
    const searchPop = $('#SearchPop');
    if (searchBtn && searchPop) {
      searchBtn.addEventListener('click', () => {
        const isOpen = searchPop.getAttribute('aria-hidden') === 'false';
        searchPop.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        if (!isOpen) setTimeout(() => $('input', searchPop)?.focus(), 30);
      });
      document.addEventListener('click', (e) => {
        if (!searchPop.contains(e.target) && !searchBtn.contains(e.target)) searchPop.setAttribute('aria-hidden', 'true');
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Hero slideshow                                                       */
  /* ------------------------------------------------------------------ */
  function initHero() {
    $$('[data-hero]').forEach((hero) => {
      const slides = $$('.hero__slide', hero);
      const dots = $$('.hero__dot', hero);
      if (slides.length < 2) return;
      let i = 0; let timer;
      const delay = parseInt(hero.dataset.delay || '5000', 10);
      const go = (n) => {
        slides[i].classList.remove('is-active'); dots[i]?.classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); dots[i]?.classList.add('is-active');
      };
      const start = () => { if (!reduceMotion && hero.dataset.autoplay !== 'false') timer = setInterval(() => go(i + 1), delay); };
      const stop = () => clearInterval(timer);
      dots.forEach((d, n) => d.addEventListener('click', () => { stop(); go(n); start(); }));
      hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Scroll-snap carousels (press, featured products, reviews)            */
  /* ------------------------------------------------------------------ */
  function initScrollers() {
    $$('[data-scroller]').forEach((root) => {
      const track = $('[data-track]', root);
      const prev = $('[data-prev]', root);
      const next = $('[data-next]', root);
      const dots = $$('[data-dot]', root);
      if (!track) return;
      const step = () => {
        const first = track.children[0];
        if (!first) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        const perPage = parseInt(root.dataset.perPage || '1', 10);
        return (first.getBoundingClientRect().width + gap) * perPage;
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      dots.forEach((d, n) => d.addEventListener('click', () => track.scrollTo({ left: step() * n, behavior: reduceMotion ? 'auto' : 'smooth' })));
      const sync = () => {
        if (!dots.length) return;
        const page = Math.round(track.scrollLeft / step());
        dots.forEach((d, n) => d.classList.toggle('is-active', n === page));
      };
      track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
      sync();

      if (root.hasAttribute('data-autoscroll') && !reduceMotion) {
        const speed = parseFloat(root.dataset.speed || '0.5');
        let paused = false;
        const half = () => track.scrollWidth / 2;
        const tick = () => {
          if (!paused) {
            track.scrollLeft += speed;
            if (track.scrollLeft >= half()) track.scrollLeft -= half();
          }
          requestAnimationFrame(tick);
        };
        const pause = () => { paused = true; };
        const play = () => { paused = false; };
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', play);
        track.addEventListener('pointerdown', pause);
        track.addEventListener('touchstart', pause, { passive: true });
        window.addEventListener('blur', pause);
        window.addEventListener('focus', play);
        prev && prev.addEventListener('click', () => { paused = true; setTimeout(play, 2500); });
        next && next.addEventListener('click', () => { paused = true; setTimeout(play, 2500); });
        setTimeout(() => { requestAnimationFrame(tick); }, 500);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Video coverflow                                                      */
  /* ------------------------------------------------------------------ */
  function initCoverflow() {
    $$('[data-coverflow]').forEach((root) => {
      const cards = $$('.coverflow__card', root);
      if (!cards.length) return;
      let active = Math.min(2, cards.length - 1);
      const render = () => {
        cards.forEach((c, n) => {
          c.className = 'coverflow__card';
          const d = n - active;
          if (d === 0) c.classList.add('is-active');
          else if (d === -1) c.classList.add('is-near', 'is-near-prev');
          else if (d === 1) c.classList.add('is-near', 'is-near-next');
          else if (d === -2) c.classList.add('is-far', 'is-far-prev');
          else if (d === 2) c.classList.add('is-far', 'is-far-next');
        });
      };
      cards.forEach((c, n) => c.addEventListener('click', (e) => {
        if (n !== active) { e.preventDefault(); active = n; render(); }
      }));
      $('[data-prev]', root)?.addEventListener('click', () => { active = (active - 1 + cards.length) % cards.length; render(); });
      $('[data-next]', root)?.addEventListener('click', () => { active = (active + 1) % cards.length; render(); });
      render();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Video modal                                                          */
  /* ------------------------------------------------------------------ */
  function videoEmbed(url) {
    if (!url) return '';
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (yt) return `<iframe src="https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Video"></iframe>`;
    const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return `<iframe src="https://player.vimeo.com/video/${vm[1]}?autoplay=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>`;
    return `<video src="${url}" controls autoplay playsinline></video>`;
  }
  function initVideoModal() {
    const modal = $('#VideoModal');
    if (!modal) return;
    const frame = $('#VideoModalFrame', modal);
    const close = () => { modal.hidden = true; frame.innerHTML = ''; document.body.style.overflow = ''; };
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-video]');
      if (!trigger) return;
      e.preventDefault();
      const url = trigger.dataset.video;
      if (!url) return;
      frame.innerHTML = videoEmbed(url);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
    $$('[data-vmodal-close]', modal).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ------------------------------------------------------------------ */
  /* Tabs (Shop by occasion / recipient)                                  */
  /* ------------------------------------------------------------------ */
  function initTabs() {
    $$('[data-tabs]').forEach((root) => {
      const tabs = $$('[role="tab"]', root);
      const panels = $$('[role="tabpanel"]', root);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        panels.forEach((p) => p.classList.toggle('is-active', p.id === tab.getAttribute('aria-controls')));
      }));
    });
  }

  /* ------------------------------------------------------------------ */
  /* Quantity steppers + AJAX quick add                                   */
  /* ------------------------------------------------------------------ */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      const input = $('input', btn.closest('.qty'));
      if (!input) return;
      const min = parseInt(input.min || '1', 10);
      let v = parseInt(input.value || '1', 10) || 1;
      v = btn.hasAttribute('data-qty-minus') ? Math.max(min, v - 1) : v + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    $('.toast__text', el).textContent = msg;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.classList.remove('is-visible'); setTimeout(() => { el.hidden = true; }, 300); }, 3200);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }

  const CartDrawer = (() => {
    const money = (cents) => {
      const fmt = (window.izzhaar && window.izzhaar.moneyFormat) || 'Rs. {{amount}}';
      const noDec = /no_decimals/.test(fmt);
      const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: noDec ? 0 : 2, maximumFractionDigits: noDec ? 0 : 2 });
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
    };
    let drawer, body, itemsEl, emptyEl, footEl, subEl, countEl;
    function cache() {
      drawer = $('#CartDrawer');
      if (!drawer) return false;
      body = $('[data-cartd-body]', drawer);
      itemsEl = $('[data-cartd-items]', drawer);
      emptyEl = $('[data-cartd-empty]', drawer);
      footEl = $('[data-cartd-foot]', drawer);
      subEl = $('[data-cartd-subtotal]', drawer);
      countEl = $('[data-cartd-count]', drawer);
      return true;
    }
    function open() { if (drawer) { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
    function close() { if (drawer) { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
    function render(cart) {
      if (!drawer) return;
      updateCartCount(cart.item_count);
      if (countEl) countEl.textContent = cart.item_count;
      itemsEl.innerHTML = '';
      if (!cart.items || cart.items.length === 0) { emptyEl.style.display = ''; footEl.hidden = true; return; }
      emptyEl.style.display = 'none';
      footEl.hidden = false;
      const tpl = $('#CartLineTemplate');
      cart.items.forEach((item) => {
        const node = tpl.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-key', item.key);
        $$('[data-line-url]', node).forEach((a) => a.setAttribute('href', item.url));
        const img = $('[data-line-img]', node);
        if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'); img.alt = item.product_title; }
        $('[data-line-title]', node).textContent = item.product_title;
        const vEl = $('[data-line-variant]', node);
        if (item.variant_title && !/default/i.test(item.variant_title)) vEl.textContent = item.variant_title; else vEl.remove();
        $('[data-line-qty]', node).value = item.quantity;
        $('[data-line-price]', node).textContent = money(item.final_line_price);
        itemsEl.appendChild(node);
      });
      subEl.textContent = money(cart.total_price);
    }
    async function fetchCart() {
      const cart = await (await fetch(window.izzhaar.routes.cart + '.js')).json();
      render(cart); return cart;
    }
    async function change(key, qty) {
      const res = await fetch(window.izzhaar.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json(); render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }
    function bind() {
      if (!cache()) return;
      $$('[data-cartd-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
      document.addEventListener('click', (e) => { if (e.target.closest('[data-cartd-open]')) { e.preventDefault(); fetchCart().then(open); } });
      drawer.addEventListener('click', (e) => {
        const line = e.target.closest('[data-key]');
        if (!line) return;
        const key = line.getAttribute('data-key');
        const input = $('[data-line-qty]', line);
        if (e.target.closest('[data-line-plus]')) change(key, parseInt(input.value, 10) + 1);
        else if (e.target.closest('[data-line-minus]')) change(key, Math.max(0, parseInt(input.value, 10) - 1));
        else if (e.target.closest('[data-line-remove]')) { line.classList.add('is-removing'); change(key, 0); }
      });
    }
    return { bind, open, close, render, fetchCart };
  })();

  function initQuickAdd() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.matches('[data-ajax-add]')) return;
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      btn && btn.classList.add('is-loading');
      try {
        const fd = new FormData(form);
        const res = await fetch(window.izzhaar.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        const cart = await (await fetch(window.izzhaar.routes.cart + '.js')).json();
        CartDrawer.render(cart);
        CartDrawer.open();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (err) {
        toast(err.message || 'Could not add to bag');
      } finally {
        btn && btn.classList.remove('is-loading');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart page                                                            */
  /* ------------------------------------------------------------------ */
  function initCart() {
    const cartForm = $('[data-cart-form]');
    if (!cartForm) return;
    cartForm.addEventListener('change', (e) => {
      if (e.target.matches('[data-line-qty]')) cartForm.submit();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Product page gallery + variant select                                */
  /* ------------------------------------------------------------------ */
  function initProduct() {
    const root = $('[data-product]');
    if (!root) return;
    const main = $('[data-main-image]', root);
    $$('[data-thumb]', root).forEach((t) => t.addEventListener('click', () => {
      $$('[data-thumb]', root).forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (main) { main.src = t.dataset.src; main.srcset = ''; }
    }));
    const variantsEl = $('[data-variants-json]', root);
    const selects = $$('[data-option-select]', root);
    if (!variantsEl || !selects.length) return;
    const variants = JSON.parse(variantsEl.textContent);
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-add-btn]', root);
    const money = (cents) => {
      const fmt = (window.izzhaar.moneyFormat || '{{amount}}');
      const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: fmt.includes('no_decimals') ? 0 : 2, maximumFractionDigits: fmt.includes('no_decimals') ? 0 : 2 });
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };
    const sync = () => {
      const chosen = selects.map((s) => s.value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '') + money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (v.featured_image && main) { main.src = v.featured_image.src; main.srcset = ''; }
    };
    selects.forEach((s) => s.addEventListener('change', sync));
  }

  /* ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader(); initHero(); initScrollers(); initCoverflow(); initVideoModal();
    initTabs(); initQty(); CartDrawer.bind(); initQuickAdd(); initCart(); initProduct();
  });

  /* Re-run inits when the Shopify theme editor re-renders a section */
  document.addEventListener('shopify:section:load', () => { initHero(); initScrollers(); initCoverflow(); initTabs(); });
})();
